// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"59eb5a2c515cd11056ab","691":"a6315bbee62d44a987d8"}[chunkId] + ".js";
};